import Swal from "sweetalert2";

const sweetAlert = {

    confirmDelete: async () => {

        const result = await Swal.fire({

            title: "Delete Record?",

            text: "You won't be able to recover this record.",

            icon: "warning",

            showCancelButton: true,

            confirmButtonColor: "#dc3545",

            cancelButtonColor: "#6c757d",

            confirmButtonText: "Yes, Delete",

            cancelButtonText: "Cancel"

        });

        return result.isConfirmed;

    }

};

export default sweetAlert;